import { render, staticRenderFns } from "./quiz-result-component-new.vue?vue&type=template&id=2095b6f8&scoped=true&"
import script from "./quiz-result-component-new.vue?vue&type=script&lang=ts&"
export * from "./quiz-result-component-new.vue?vue&type=script&lang=ts&"
import style0 from "./quiz-result-component-new.vue?vue&type=style&index=0&id=2095b6f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2095b6f8",
  null
  
)

export default component.exports